import { render, staticRenderFns } from "./CoozzyFormTag.vue?vue&type=template&id=003f0a56&scoped=true"
import script from "./CoozzyFormTag.vue?vue&type=script&lang=js"
export * from "./CoozzyFormTag.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormTag.vue?vue&type=style&index=0&id=003f0a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f0a56",
  null
  
)

export default component.exports